<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/CommandLine';
    let nextLink= '/Documentation/Under_the_Hood/Editor_Framework';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="under-the-hood-1"
  bind:intersecting={visibleById["under-the-hood-1"]}
  onIntersectChange={(visible) => setVisible("under-the-hood-1", visible)}
>Under the Hood</SectionComponent>
<p>Before you dive deeper under the hood of this project, we invite you to read about the<br>
<a href="/Background">Background</a> that inspired the creation of this tool.</p>
<p>This section can be roughly divided into three parts:</p>
<ol>
<li>Information about the core <a
  href="/Documentation/Under_the_Hood/Editor_Framework"
>framework</a> of Freon — the classes used to build the editors.</li>
<li>Information on the <a
  href="/Documentation/Under_the_Hood/FreTool_Interfaces"
>interfaces of all fre-tools</a> — such as the scoper and validator,
used and generated by Freon.</li>
<li>Information on the (open) source code of Freon can be found
on <a href="https://github.com/freon4dsl/Freon4dsl" target="_blank">https://github.com/freon4dsl/Freon4dsl</a>.</li>
</ol>


<PrevNextSection {prevLink} {nextLink} />